import React, { useContext, useMemo } from "react";
import { useIntl } from "react-intl";

// mui
import IconButton from "@mui/material/IconButton";

// image
import copyIcon from "../../../../../../../../../images/icon_copy/icon_copy.svg";
import copyDisableIcon from "../../../../../../../../../images/icon_copy/copy_disable.svg";

// component
import TooltipBasic from "../../../../../../../../common/components/tooltip/TooltipBasic";

// utils
import { isEmpty } from "../../../../../../../../common/utils";
import { StoreContext } from "../../../../../../../../store/StoreProvider";
import Act from "../../../../../../../../store/actions";
import { OCR_CONTENT } from "../../../Config";

const CopyTool = () => {
  const [state, dispatch] = useContext(StoreContext);
  const { digitalAI } = state;
  const { ocrImgList, pagination } = digitalAI;

  const { activePage } = pagination;
  const intl = useIntl();

  // 複製全部內容
  // const displayValue = useMemo(() => {
  //   if (isEmpty(ocrImgList)) {
  //     return "";
  //   }
  //
  //   return ocrImgList
  //     .filter((el) => OCR_CONTENT in el)
  //     .map((el) => el[OCR_CONTENT])
  //     .join("\n\n");
  // }, [ocrImgList]);

  // 複製當前單一個結果
  // const displayValue = useMemo(() => {
  //   if (isEmpty(ocrImgList) || isEmpty(ocrImgList[activePage])) {
  //     return null;
  //   }
  //
  //   if (!(OCR_CONTENT in ocrImgList[activePage])) {
  //     return null;
  //   }
  //   return ocrImgList[activePage][OCR_CONTENT];
  // }, [ocrImgList, activePage]);

  const handleCopy = () => {
    if (!isEmpty(ocrImgList[activePage]?.ocrContent)) {
      navigator.clipboard
        .writeText(ocrImgList[activePage]?.ocrContent)
        .then(() => {
          dispatch({
            type: Act.COMMON_SET_MESSAGE,
            payload: {
              open: true,
              content: intl.formatMessage({
                id: "sna.sidetool.digitalAITool.ocr.copy.msg",
                defaultMessage: "Text copied to clipboard successfully!",
              }),
            },
          });
        })
        .catch((error) => {
          dispatch({
            type: Act.COMMON_SET_MESSAGE,
            payload: {
              open: true,
              content: intl.formatMessage(
                {
                  id: "sna.sidetool.digitalAITool.ocr.copyErr.msg",
                  defaultMessage: `Error copying text to clipboard: {msg}`,
                },
                {
                  msg: error,
                }
              ),
            },
          });
        });
    }
  };

  return (
    <TooltipBasic
      tooltipProps={{
        title: intl.formatMessage({
          id: "sna.sidetool.digitalAITool.ocr.copy",
          defaultMessage: "複製",
        }),
        placement: "right",
      }}
    >
      <span>
        <IconButton
          size="small"
          onClick={handleCopy}
          disabled={isEmpty(ocrImgList[activePage]?.ocrContent)}
        >
          <img
            src={
              isEmpty(ocrImgList[activePage]?.ocrContent)
                ? copyDisableIcon
                : copyIcon
            }
            alt="copy"
            width={24}
            height={24}
          />
        </IconButton>
      </span>
    </TooltipBasic>
  );
};

export default CopyTool;
